import React from 'react';
import {hydrate} from 'react-dom';
import {Router, browserHistory} from 'react-router';
import {Provider} from 'react-redux';
import Validators from 'redux-form-validators';
import {FormattedMessage, addLocaleData, IntlProvider} from 'react-intl';

import routes from './routes';
import configureStore from './store/configureStore';
import {getTranslationsData} from './utils/translation';
import {reportError} from './utils/error-reporter';
import {acceptLangs} from '../common/localization';
import {PushEvent} from './utils/googleTagManager';
import Page500 from './pages/500';
import loadIntl from '../common/load-intl';

loadIntl(window);

/* eslint-disable global-require, import/no-dynamic-require */
acceptLangs.forEach(lang => {
  const data = require(`react-intl/locale-data/${lang}`);
  addLocaleData(data);
});
/* eslint-enable global-require, import/no-dynamic-require */

const initialState = window.__INITIAL_STATE__;
const store = configureStore(initialState);

// eslint-disable-next-line react/display-name
Validators.formatMessage = function(msg) {
  return <FormattedMessage {...msg.props || msg} />;
};

browserHistory.listen(() => {
  PushEvent('Virtual Pageview');
});

try {
  hydrate(
    <IntlProvider
      locale={initialState.xl.localization.lang}
      messages={getTranslationsData(initialState.xl.localization.translation)}
    >
      <Provider store={store}>
        <Router history={browserHistory} routes={routes} />
      </Provider>
    </IntlProvider>,
    document.getElementById('react-view')
  );
} catch (e) {
  reportError(e);
  hydrate(
    <IntlProvider
      locale={initialState.xl.localization.lang}
      messages={getTranslationsData(initialState.xl.localization.translation)}
    >
      <Page500 />
    </IntlProvider>,
    document.getElementById('react-view')
  );
}



// WEBPACK FOOTER //
// ./client.jsx